<template>
    <div class="FAQ">
      <FlightHeader :hideAppDueDate="true" />
      <div class="container">
        <div class="row">
          <div class="col-12" style="text-align: center;margin-bottom: 2em;text-transform: uppercase;">
            <h5>Application Q's</h5>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Is this a real application? For a real internship?</h4>
            <p>Instead of stopping to ponder the existence of reality, we’ll keep it short and say YES.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>What if I don't have a portfolio?</h4>
            <p>That's okay. We know creativity comes through in many forms. We designed this application to give you alternative ways to showcase your creative thinking that aren't tied to a portfolio, cover letter or resume.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Do I have to answer all the questions?</h4>
            <p>You can submit your application after the first 9 required answers at the top are completed. All other questions are optional and are meant to serve as infinite ways for you to showcase your creativity.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Will I be penalized for not answering all the questions?</h4>
            <p>No. The number of questions you do or do not answer will not affect your chances. We're looking for creativity, not quantity.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>How many questions are there?</h4>
            <p>Counter question: Can you put a number on potential? On possibilities? On Portland coffee shops?</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>When’s my application due?</h4>
            <p>Deadline extended: April 9, 2020 at 11:59PM PST.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="text-align: center;margin-bottom: 2em;text-transform: uppercase;">
            <h5>Flight School Q's</h5>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>What the heck is Flight School?</h4>
            <p>It’s <a href="https://www.swift.co/en/home">Swift’s</a> summer internship program, where we help you to get on a greater creative trajectory. Unfortunately if you’re looking for a real flight school, we have yet to develop that wing of our agency.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>What will I be doing?</h4>
            <p>Working on client projects, shootin’ the shiet, getting to know people, eating awesome food, experiencing the agency world, enjoying Portland summer, petting all the dogs, and most importantly, bragging to your friends about how you’re interning at Swift.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Do I have to get coffee for everyone?</h4>
            <p>Only if you want to, but that’s not part of your job description.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>How long is the program?</h4>
            <p>It’s flexible. It usually starts in early summer and ends in late August. But we’ll work with you to accommodate graduation and other conflicts.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Do I need to have an advertising background or agency experience?</h4>
            <p>You don’t have to have an advertising background or experience, but you should have a portfolio that we can look at.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Do I get the kee$h?</h4>
            <p>Yes. You get all the hourly kee$h.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>When can I announce to all my IG followers that I’m going to Flight School?</h4>
            <p>Final decisions will be made in very early April.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>Do I get a job afterwards?</h4>
            <p>No guarantees, but it’s a way to get on track for a career.</p>
          </div>
          <div class="faq-question col-12 col-md-6">
            <h4>More questions? Ask away.</h4>
            <p><a href="mailto:careers@swift.co">careers@swift.co</a></p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
</template>

<script>
import FlightHeader from '@/components/FlightHeader'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    FlightHeader,
    Footer
  }
}
</script>

<style lang="scss" scoped>
  .FAQ {
    background-color: #0000C6;

    header {
      position: relative;
      margin-bottom: 10em;
    }
    .container {

      .row {
        margin-bottom: 10em;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>